import { FC } from 'react';
import { Flex, Text } from '@chakra-ui/react';

import { FileDetailsFileFragment, FileProcess } from '../../graphql/generated';
import { FileProcessErrors } from './file-process-errors';
import { FileProcessStatus } from './file-process-status';
import { RefetchFileDetails } from './file-process-utils';

type FileProcessesProps = {
  fileProcesses: FileDetailsFileFragment['processes'];
  refetchFileDetails: RefetchFileDetails;
};

export const FileProcesses: FC<FileProcessesProps> = ({
  fileProcesses,
  refetchFileDetails,
}) => {
  if (fileProcesses.length === 0) return null;

  const handleViewMore = async (nextLimit: number) => {
    await refetchFileDetails({
      errorsPagination: {
        limit: nextLimit,
      },
    });
  };

  const hasErrors = (fileProcess: FileProcess) =>
    fileProcess.errors && fileProcess.errors.errors.length > 0;

  return (
    <>
      {fileProcesses.map((fileProcess, index) => {
        const uniqueKey = `${fileProcess.name}-${index}`;
        
        if (hasErrors(fileProcess)) {
          return (
            <FileProcessErrors
              key={uniqueKey}
              fileProcess={fileProcess}
              viewMore={handleViewMore}
            />
          );
        }

        return (
          <Flex
            key={uniqueKey}
            justify="space-between"
            data-testid="file-process"
          >
            <Text>{fileProcess.name}</Text>
            <FileProcessStatus fileProcess={fileProcess} />
          </Flex>
        );
      })}
    </>
  );
};
